export const transactionLevels: { [key: string]: number } = {
  intro: 25,
  investor: 1000,
  trader: 3000,
  daytrader: 10000,
};